export default function buildPipelineIntegrationUpdateRequests({
  selectedPipelines,
  selectedIntegrationId,
  selectedPlaybookId,
  formData,
}) {
  return selectedPipelines.map(pipeline => {
    const { consentCategoryId, consentMode, ...pipelineVars } = formData[pipeline.id] ?? {};
    const existingPipelineIntegration = pipeline.pipelineIntegrations?.find(
      pipelineIntegration => pipelineIntegration.integrationId === selectedIntegrationId
    );

    return {
      pipelineId: pipeline.id,
      integrationId: selectedIntegrationId,
      playbookId: selectedPlaybookId,
      pipelineVars: {
        ...(existingPipelineIntegration?.revision?.pipelineVars ?? {}),
        ...pipelineVars,
      },
      disabled: existingPipelineIntegration?.disabled ?? false,
      readyForDeploy: true,
      stagedForDelete: false,
      ...(existingPipelineIntegration?.id && {
        pipelineIntegrationId: existingPipelineIntegration.id,
      }),
      ...(existingPipelineIntegration?.revision?.id && {
        stagedRevisionId: existingPipelineIntegration.revision.id,
      }),
      ...(existingPipelineIntegration?.consent?.id && {
        consentId: existingPipelineIntegration.consent.id,
      }),
      ...(consentCategoryId && { consentCategoryId }),
      ...(consentMode && { consentMode }),
    };
  });
}
